import React from "react";
import PropTypes from "prop-types";
import Section from "../../common/Section";
import Row from "../../common/Row";
import ValidationStatusList from "./VRValidatieStatusList";
import Button from "../../common/Button";
import Form from "../../common/Form";
import Fieldset from "../../common/Fieldset";
import moment from "moment";
import DownloadUploadFile from "../../common/DownloadUploadFiles";
import * as constants from "../../../constants/DomainConstants";

const VRIndienenForm = ({ indienen, onSave, color, pdf, isPollingDocument, generatePdf }) => {
    let itemsFrontendList = [];

    const heeftWarnings = indienen.nrOfWarnings > 0;
    const indienenIsDisabled = heeftWarnings || indienen.isIndiendatumVerstreken || indienen.status == constants.REDEN_VAN_STATUS_INGEDIEND;
    const uitersteDatumIndienen = indienen.uitersteDatumIndienen ? moment(indienen.uitersteDatumIndienen).format("DD-MM-YYYY") : null;

    return (<Section title="Dien in" color={color}>
        <Form
            name="indienen"
            rightButtonLabel="Dien in"
            onRightButtonClick={onSave}
            rightButtonDisabled={indienenIsDisabled}
            isNotRequired>
            <Fieldset>
                <p>Controleer goed of je het rapport correct hebt ingevuld.</p>
                <p>Wanneer je je rapport hebt ingediend, kan je geen wijzigingen meer aanbrengen!</p>
                <p>Nadat je op "Dien in" drukt, zal er een mail met een PDF van jouw rapport verstuurd worden naar de indiener van het rapport.</p>
                {indienen.isEindrapport ? <p>Opgelet: zorg er voor dat alle noodzakelijke bijlagen zijn toegevoegd.</p> : null}
                <p>Je kan je rapport indienen tot en met {uitersteDatumIndienen}</p>
                <br />
                {heeftWarnings ? <p style={{ color: 'red' }}>Het rapport is nog niet klaar om ingediend te worden wegens:</p> : ""}
                <br />
                {heeftWarnings ? <ValidationStatusList items={indienen.validatieStatussen} itemsFrontend={itemsFrontendList} /> : ""}
            </Fieldset>

            <Fieldset>
                <Row>
                    {indienen.voortgangsrapportPDFGegenereerd ?
                        <DownloadUploadFile
                            dossierId={indienen.voortgangsrapportId}
                            title="PDF van het voortgangsrapport"
                            size={6}
                            tab=""
                            component=""
                            files={isPollingDocument ? [] : pdf.files}
                            color={color}
                            downloadOnly
                            isPdf /> : ""}

                    <div className="o-col-6" style={{paddingTop: '15px'}}>
                        {isPollingDocument ? <p>Even geduld a.u.b.</p> : ""}
                        {indienen.datumVoortgangsrapportPDFGeneratie ? <p>Documenten gegenereerd op: {moment(indienen.datumVoortgangsrapportPDFGeneratie).format("DD-MM-YYYY HH:mm")}</p> : ""}
                        <Button onClick={generatePdf} disabled={isPollingDocument || indienen.status == constants.REDEN_VAN_STATUS_INGEDIEND}>Genereer PDF</Button>
                    </div>
                </Row>
            </Fieldset>
        </Form>
    </Section>);
};

VRIndienenForm.propTypes = {
    onSave: PropTypes.func,
    indienen: PropTypes.object.isRequired,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    generatePdf: PropTypes.func,
    isPollingDocument: PropTypes.bool,
    pdf: PropTypes.object
};

export default VRIndienenForm;